import ConfirmCreateDialogModal from './confirm-create-dialog-modal/modal';
import NewContactIframeModal from './new-contact-frame-modal/modal';
import { NewContactIframeModalContext, NewContactIframeModalContextType } from './new-contact-iframe-modal-context';
import { InitContactDialogInput } from 'api-new/generated';
import useToggle from 'hooks/use-toggle';
import { FC, PropsWithChildren, useState } from 'react';

export const NewContactWrapper: FC<PropsWithChildren> = ({ children }) => {
  const [isShowContactIframeModal, setIsShowContactIframeModal] = useState<boolean>(false);
  const [contactId, setContactId] = useState<number | undefined>(undefined);
  const openConfirmCreateNewDialogToggleState = useToggle<InitContactDialogInput>(false);

  const handleOnCloseContactIframe = () => {
    setIsShowContactIframeModal(false);
    setContactId(undefined);
  };

  const handleConfirmDialogModal = (contact: InitContactDialogInput) => {
    openConfirmCreateNewDialogToggleState.setData(contact);
    openConfirmCreateNewDialogToggleState.open();
  };

  const handleDialogCreated = (contactId: number) => {
    setContactId(contactId);
    setIsShowContactIframeModal(true);
  };

  const handleOpenContactIframe = (contactIframeType: NewContactIframeModalContextType) => {
    setContactId(contactIframeType.contactId);
    setIsShowContactIframeModal(true);
  };

  return (
    <NewContactIframeModalContext.Provider
      value={{
        openContactIframe: handleOpenContactIframe,
        openConfirmDialogModal: handleConfirmDialogModal
      }}
    >
      {children}
      {isShowContactIframeModal && contactId && (
        <NewContactIframeModal onClose={handleOnCloseContactIframe} contactId={contactId} />
      )}
      {openConfirmCreateNewDialogToggleState.opened && (
        <ConfirmCreateDialogModal state={openConfirmCreateNewDialogToggleState} onDialogCreated={handleDialogCreated} />
      )}
    </NewContactIframeModalContext.Provider>
  );
};
